(function () {
  var FLAG = 'pns_unlocked';
  var COLORS = ['#0b2545', '#13315c', '#1c4b8f', '#2563a8', '#8fb9ff', '#ffd166', '#ffb703', '#ffffff'];
  var SHAPES = ['rect', 'rect', 'strip', 'circle'];
  var D2R = Math.PI / 180;

  function rand(a, b) {
    return a + Math.random() * (b - a);
  }

  function pick(list) {
    return list[(Math.random() * list.length) | 0];
  }

  function celebrate() {
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:2147483000';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0;
    var H = 0;

    function resize() {
      W = window.innerWidth;
      H = window.innerHeight;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);

    var pieces = [];
    var scale = Math.min(1.5, Math.max(0.75, W / 1200));

    function spawn(x, y, angle, spread, minSpeed, maxSpeed, count, gravity) {
      for (var i = 0; i < count; i++) {
        var a = angle + rand(-spread, spread);
        var s = rand(minSpeed, maxSpeed);
        pieces.push({
          x: x,
          y: y,
          vx: Math.cos(a) * s,
          vy: Math.sin(a) * s,
          g: gravity,
          drag: rand(0.985, 0.995),
          w: rand(6, 13),
          h: rand(9, 17),
          rot: rand(0, Math.PI * 2),
          vr: rand(-0.3, 0.3),
          wob: rand(0, Math.PI * 2),
          wobV: rand(0.08, 0.2),
          color: pick(COLORS),
          shape: pick(SHAPES)
        });
      }
    }

    spawn(0, H * 0.98, -62 * D2R, 20 * D2R, 18 * scale, 31 * scale, Math.round(95 * scale), 0.42);
    spawn(W, H * 0.98, -118 * D2R, 20 * D2R, 18 * scale, 31 * scale, Math.round(95 * scale), 0.42);

    var DURATION = 7000;
    var FADE = 1200;
    var RAIN_UNTIL = 2600;
    var started = null;
    var secondBurst = false;
    var thirdBurst = false;
    var rainTick = 0;

    function frame(now) {
      if (started === null) started = now;
      var t = now - started;

      if (!secondBurst && t > 400) {
        secondBurst = true;
        spawn(W * 0.5, H * 0.55, -90 * D2R, 180 * D2R, 8 * scale, 21 * scale, Math.round(110 * scale), 0.34);
      }
      if (!thirdBurst && t > 950) {
        thirdBurst = true;
        spawn(W * 0.2, H * 0.95, -70 * D2R, 26 * D2R, 15 * scale, 26 * scale, Math.round(55 * scale), 0.4);
        spawn(W * 0.8, H * 0.95, -110 * D2R, 26 * D2R, 15 * scale, 26 * scale, Math.round(55 * scale), 0.4);
      }

      if (t < RAIN_UNTIL) {
        rainTick++;
        if (rainTick % 2 === 0) {
          for (var r = 0; r < 3; r++) {
            pieces.push({
              x: rand(0, W),
              y: rand(-70, -10),
              vx: rand(-1.3, 1.3),
              vy: rand(2, 5),
              g: 0.05,
              drag: 0.999,
              w: rand(6, 11),
              h: rand(9, 15),
              rot: rand(0, Math.PI * 2),
              vr: rand(-0.22, 0.22),
              wob: rand(0, Math.PI * 2),
              wobV: rand(0.07, 0.16),
              color: pick(COLORS),
              shape: pick(SHAPES)
            });
          }
        }
      }

      var alpha = t > DURATION - FADE ? Math.max(0, (DURATION - t) / FADE) : 1;
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = alpha;

      for (var i = 0; i < pieces.length; i++) {
        var p = pieces[i];
        p.vy += p.g;
        p.vx *= p.drag;
        p.vy *= p.drag;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        p.wob += p.wobV;

        if (p.y > H + 90 || p.x < -90 || p.x > W + 90) continue;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.scale(Math.cos(p.wob), 1);
        ctx.fillStyle = p.color;
        if (p.shape === 'circle') {
          ctx.beginPath();
          ctx.arc(0, 0, p.w * 0.45, 0, Math.PI * 2);
          ctx.fill();
        } else if (p.shape === 'strip') {
          ctx.fillRect(-p.w * 0.25, -p.h * 0.8, p.w * 0.5, p.h * 1.6);
        } else {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }
        ctx.restore();
      }

      ctx.globalAlpha = 1;

      if (t < DURATION) {
        window.requestAnimationFrame(frame);
      } else {
        window.removeEventListener('resize', resize);
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }
    }

    window.requestAnimationFrame(frame);
  }

  function run() {
    var unlocked = false;
    try {
      unlocked = sessionStorage.getItem(FLAG) === '1';
      if (unlocked) sessionStorage.removeItem(FLAG);
    } catch (e) {
      return;
    }
    if (!unlocked) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    celebrate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
